// extracted by mini-css-extract-plugin
export default {"phoneInput":"CustomPhoneInput_phoneInput__gg5qV","phoneInputContainer":"CustomPhoneInput_phoneInputContainer__+-54e","phoneLabel":"CustomPhoneInput_phoneLabel__xee0b"};